import React from 'react';
import EmptyIcon from "../../assets/empty.png";
import "./style.less";
import { STYLE_PREFIX } from "../../utils/const";
var Empty = function Empty() {
  return /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "empty-wrapper")
  }, /*#__PURE__*/React.createElement("img", {
    className: "".concat(STYLE_PREFIX, "empty-wrapper-icon"),
    src: EmptyIcon
  }), /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "empty-wrapper-title")
  }, "\u8BE5\u5206\u7C7B\u4E0B\u6682\u65E0\u6D88\u606F"), /*#__PURE__*/React.createElement("div", {
    className: "".concat(STYLE_PREFIX, "empty-wrapper-desc")
  }, "\u60A8\u8FD8\u6CA1\u6536\u5230\u4EFB\u4F55\u6D88\u606F\uFF0C\u5F85\u4F1A\u513F\u518D\u6765\u770B\u770B\u5427"));
};
export default Empty;